const state = {
  view: null,
  projectLayers: []
}

const getters = {
  // 只改这里：unwrap 一层
  view: (state) => (state.view ? state.view.instance : null),
  projectLayers: (state) => state.projectLayers
}

const mutations = {
  changeView: (state, view) => {
    state.view = view ? Object.freeze({ instance: view }) : null
  },
  changeProjectLayers: (state, projectLayers = []) => {
    state.projectLayers = projectLayers
  }
}

const actions = {
  changeView ({ commit }, view) {
    commit('changeView', view)
  },
  changeProjectLayers ({ commit }, projectLayers) {
    commit('changeProjectLayers', projectLayers)
  }
}

export default { state, getters, mutations, actions }
